import { Storage } from 'aws-amplify';
import Logger from '@/common/utils/Logger';
import Utils from '@/common/utils/utils';
import WarningIcon from '@material-ui/icons/WarningTwoTone';
import { createThumbnailAPI } from '@/service/attachFileService';
import Constant from '@/common/constant/Constant';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

export const FileUpload = (props) => {

    // function LinearProgressWithLabel(propProgress) {
    //     let process = propProgress.value ? Math.round(propProgress.value) : 0;
    //     return process < 100 ? (
    //         <Box display="flex" alignItems="center" style={{ marginTop: 2 }}>
    //             <Box width="100%" mr={1} minWidth={50}>
    //                 <LinearProgress variant="determinate" color="secondary" {...propProgress}/>
    //             </Box>
    //             <Box minWidth={35}>
    //                 <Typography variant="body2" color="secondary">{`${process}%`}</Typography>
    //             </Box>
    //         </Box>
    //     ) : null;
    // }

    function renderFileUpload() {
        let fileActive = Utils.isEmptyObject(props.fileUploadInfor);
        let fileNameClass = props.isAlignLeft ? 'file-upload-name' : 'file-upload-name--change';
        const lastDot = props.chatPost.content.lastIndexOf('.');
        let fileExtention = ''
        let fileName
        if(props.chatPost.content.substring(0, lastDot).length === 0){
           fileName = props.chatPost.content.length > 50 ?  props.chatPost.content.slice(0,50) + '...' :  props.chatPost.content;
        }else{
            fileExtention = props.chatPost.content.substring(lastDot + 1);
            fileName = props.chatPost.content.substring(0, lastDot).length > 50 ?  props.chatPost.content.substring(0, lastDot).slice(0,50) + '...' : props.chatPost.content.substring(0, lastDot)+'.' ;
        } 

        let renderUploadFiles = [];
        let elementChild = (
            <>
                {(props?.isPdf && props?.isDisplaySplitPdfSwitch) && (
                    <ArrowDropDownIcon
                        onClick={props?.onClickToggleExpandedPdf}
                        className={`${
                            props.fileUploadInfor?.isExpand
                                ? 'icon-pdf-expand'
                                : 'icon-pdf-collapse'
                        }`}
                    />
                )}
                <a
                    className={fileActive ? `${fileNameClass} file-upload-active` : fileNameClass}
                    target="_blank"
                    download={props.chatPost.content}
                    onClick={() => (fileActive ? downloadFileFromS3(props.chatPost) : null)}
                >
                    {`${fileName}${fileExtention} (${getFileSizeDisplay(props.chatPost.fileSize)})`}
                    {props.fileUploadInfor?.status === false && (
                        <WarningIcon color="error" size="small" />
                    )}
                </a>
            </>
        );
        renderUploadFiles.push(elementChild);
        /* if (!Utils.isEmptyObject(props.fileUploadInfor) && props.fileUploadInfor.status) {
            renderUploadFiles.push(
                <LinearProgressWithLabel value={props.fileUploadInfor.progress} />
            );
        } */
        return renderUploadFiles;
    }
    return renderFileUpload();
};

export const uploadFileToS3 = async (setFileUploading, fileUpload, API, type) => {
    try {
        if (!fileUpload || !fileUpload.file || Utils.isEmptyObject(fileUpload.file)) {
            return false;
        }
        const file = fileUpload.file;
        Logger.info('uploadFileToS3: Upload file name: ', file.name);
        let result = await Storage.put(fileUpload.key, file, {
            contentType: file.type,
            level: 'public',
            contentDisposition: `inline; filename=${encodeURIComponent(file.name)}`,
            progressCallback(progress) {
                Logger.info(`Uploaded: ${progress.loaded}/${progress.total}`);
                fileUpload.progress = (progress.loaded / progress.total) * 100;

                setFileUploading({...fileUpload});
            },
        })
            .then((data) => {
                Logger.info('uploadFileToS3: result - ', data);
                return data;
            })
            .catch((error) => {
                Logger.error('uploadFileToS3: Error uploading file - ', error);
                return false;
            });
        let fileExtention = file.name.split('.').pop().toLocaleLowerCase();
        // if (type && Constant.ATTACH_FILE_IMAGE_EXTENSIONS.split(',').includes(fileExtention)) {
        //     let requestBody = {
        //         updateAttachFileRequestDto: {
        //             key: result.key,
        //             positionUpload: type
        //         }
        //     }
        //     await createThumbnailAPI(API, requestBody);
        // }
    
        return result;
    } catch (error) {
        Logger.error('uploadFileToS3: Exception - ', error);
    }
    return false;
};

const downloadFileFromS3 = async (fileUpload) => {
    if (Utils.isEmptyString(fileUpload?.fileUrl)) {
        return;
    }
    let dataDownload;
    const a = document.createElement('a');
    dataDownload = await Storage.get(`${fileUpload.fileUrl}`);
    a.href = dataDownload;
    a.download = fileUpload.content;
    a.target = '_blank';
    a.click();
    a.remove();
};

export const getFileSizeDisplay = (totalByte) => {
    if (!totalByte) return '0';
    if (totalByte < 1024) {
        return `${totalByte} bytes`;
    }
    let num = totalByte / 1024;
    if (totalByte < 1024 * 1024) {
        return `${Math.round(num * 100) / 100} KB`;
    }
    num = num / 1024;
    if (totalByte < 1024 * 1024 * 1024) {
        return `${Math.round(num * 100) / 100} MB`;
    }
    num = num / 1024;
    return `${Math.round(num * 100) / 100} GB`;
};
